import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Badge, UpgradePopover } from '..'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
    padding: '8px 0',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  radio: {
    width: 20,
    height: 20,
    flex: 'none',
    marginTop: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    boxSizing: 'border-box',
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  title: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#002E47',
  },
  description: {
    display: 'block',
    marginTop: 2,
    fontSize: '13px',
    color: '#637381',
  },
})

/** One learner-authentication option: radio, title and description. */
const AccordionSummaryContent = props => {
  const {
    accessRule,
    handleClickSwitch,
    contentHeader,
    contentDescription,
    id,
    badgeType,
    open,
    anchorEl,
    handleClose,
    popupHeader,
    popupContent,
    accessRuleEqual,
  } = props
  const classes = useStyles()
  const checked = accessRule == accessRuleEqual

  return (
    <div
      className={classes.root}
      role="radio"
      aria-checked={checked}
      tabIndex={0}
      // The event is used to anchor the upgrade popover.
      onClick={event => handleClickSwitch(event)}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') handleClickSwitch(event)
      }}
    >
      <span
        className={classes.radio}
        style={{ border: `2px solid ${checked ? '#015FFB' : '#919EAB'}` }}
      >
        <span
          className={classes.dot}
          style={{ background: checked ? '#015FFB' : 'transparent' }}
        />
      </span>
      <span>
        <span className={classes.titleRow}>
          <span className={classes.title}>{contentHeader}</span>
          {badgeType && <Badge type={badgeType} />}
        </span>
        <span className={classes.description}>{contentDescription}</span>
      </span>

      <UpgradePopover
        id={id}
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        header={popupHeader}
        content={popupContent}
        accessRuleEqual={accessRuleEqual}
      />
    </div>
  )
}

export default AccordionSummaryContent
